import { generateLoginPath } from "./authorization";

const LoginButton = props => {
    const redirectLogin = () => {
        window.location = generateLoginPath(window.location.toString());
    };

    return (<button onClick={redirectLogin}>Login</button>);
}

export default LoginButton;